import React from 'react';
import {
  Box,
  Typography,
  Button
} from '@mui/material';

const CTASection = ({ onNavigateToAuth }) => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
        backgroundColor: '#4a5568',
        color: '#fff',
        textAlign: 'center'
      }}
    >
      <Box sx={{ maxWidth: '600px', mx: 'auto', px: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h3"
          sx={{
            fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.2rem' },
            fontWeight: 400,
            mb: { xs: 2, md: 3 },
            color: '#ffffff'
          }}
        >
          Ready to streamline your beauty business?
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: '1rem', sm: '1.05rem', md: '1.1rem' },
            fontWeight: 400,
            mb: { xs: 3, md: 4 },
            color: '#a0aec0',
            px: { xs: 1, md: 0 }
          }}
        >
          Join beauty brands who focus on what they do best - creating amazing products.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={onNavigateToAuth}
          sx={{
            backgroundColor: '#f6ad55',
            color: '#ffffff',
            fontWeight: 500,
            px: { xs: 4, md: 5 },
            py: { xs: 1.5, md: 2 },
            textTransform: 'none',
            fontSize: { xs: '1rem', md: '1.1rem' },
            borderRadius: 2,
            width: { xs: '100%', sm: 'auto' },
            maxWidth: { xs: '100%', sm: 'none' },
            '&:hover': {
              backgroundColor: '#ed8936'
            }
          }}
        >
          Get started
        </Button>
      </Box>
    </Box>
  );
};

export default CTASection;
